// externals
import { useContext } from 'react';

// components
import { SlideOut } from '@interstate/components/SlideOut';
import DealActivity from '../dealActivity/DealActivity.interstate';
import { NavDrawerContext } from './NavDrawerContext';

// hooks
import { useLocationChange } from '../common/useLocationChange';
import { useDealTabChange } from '../common/useDealTabChange';

const NavigationDrawerInterstate = () => {
    const { drawerOpen, setDrawerOpen, toggleDrawer } = useContext(NavDrawerContext);

    useLocationChange(() => {
        setDrawerOpen(false);
    });

    useDealTabChange(() => {
        setDrawerOpen(false);
    });

    return (
        <SlideOut
            className="interstate"
            show={drawerOpen}
            onHide={toggleDrawer}
            position="left"
            panelWidth="392px"
            sx={{
                '#ids-SlideOut-content': {
                    paddingBottom: '80px'
                }
            }}
            header={
                // TODO: US1183743 - NavDrawer Typography
                <h3
                    style={{
                        fontSize: '20px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: '120%',
                        textTransform: 'capitalize',
                        color: '#000'
                    }}
                >
                    Deal Progress
                </h3>
            }
        >
            <DealActivity />
        </SlideOut>
    );
};

export default NavigationDrawerInterstate;
